export const closeWithFallback = () => {
  if (window.opener) {
    try {
      window.close()
      return
    } catch {}
  }

  if (window.history.length > 1) {
    window.history.back()
    return
  }

  window.location.replace('about:blank')
}
